import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchLocalProducts, fetchLocalProduct, fetchLocalProductBySlug } from "../services";

export const fetchLocalProductsData = createAsyncThunk(
  "localProducts/fetchLocalProductsData",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchLocalProducts();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchLocalProductData = createAsyncThunk(
  "localProducts/fetchLocalProductData",
  async (productId, { rejectWithValue }) => {
    try {
      const data = await fetchLocalProduct(productId);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchLocalProductDataBySlug = createAsyncThunk(
  "localProducts/fetchLocalProductDataBySlug",
  async ({ countryCode, productSlug }, { rejectWithValue }) => {
    try {
      const data = await fetchLocalProductBySlug(countryCode, productSlug);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const localProductsSlice = createSlice({
  name: "products",
  initialState: {
    data: [],
    loading: true,
    error: null,
    product: null,

  },
  reducers: {
    // Puedes agregar más acciones sincronas si es necesario
    setProduct: (state, action) => {
      state.product = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLocalProductData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLocalProductData.fulfilled, (state, action) => {
        state.loading = false;
        state.product = action.payload;
      })
      .addCase(fetchLocalProductData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchLocalProductsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLocalProductsData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchLocalProductsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchLocalProductDataBySlug.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLocalProductDataBySlug.fulfilled, (state, action) => {
        state.loading = false;
        state.product = action.payload;
      })
      .addCase(fetchLocalProductDataBySlug.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setProduct } = localProductsSlice.actions;
export default localProductsSlice.reducer;
